//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "vux";
import { mapState } from "vuex";

import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import { Dialog } from "vant";
import SrmCommonUtils from "@/utils/SrmCommonUtils"

export default {
  data() {
    return {
      searchValue: "",
      auctions: [],

      /** 拒绝确认Dialog */
      rejectIndex: -1,
      rejectReason: "",
      showRejectDialog: false,

      /** 刷新用变量 */
      pageIndex: 1,
      pageRows: 10,
      refreshing: true,
      finished: false,
      loading: false,
    };
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
      dicCodes: (state) => state.user.dicCodes,
    }),
  },
  created() {
    this.requestAuctions();
  },
  activated: function () {},
  methods: {
    //搜索 输入
    onInput() {
      this.auctions.splice(0, this.auctions.length); //清空数据
      this.onRefresh(); //重新请求
    },
    onRefresh() {
      //状态设置
      this.refreshing = true;
      this.loading = true;
      this.finished = false;
      //页数设置
      this.pageIndex = 1;
      this.onLoad();
    },
    onLoad() {
      this.requestAuctions();
    },
    requestAuctions() {
      fetch
        .listByPageForBidToMobile({
          lan: this.languageCode,
          pageIndex: this.pageIndex, //页数
          pageRows: this.pageRows,
          auctionNum: this.searchValue,
        })
        .then((res) => {
          console.log(res);
          //状态设置
          this.refreshing = false;
          this.loading = false;
          if (res.status === "S") {
            if (res.status === "S") {
              //清楚最后多余的数据
              const curPageIndex = res.page.curIndex; //页数
              const curIndex = (curPageIndex - 1) * this.pageRows; //index
              const lastLength = this.auctions.length - curIndex; //剩余长度
              this.auctions.splice(curIndex, lastLength);

              this.auctions = this.auctions.concat(res.data); //拼接数据
              if (res.data.length >= this.pageRows) {
                this.pageIndex = res.page.nextIndex; //更新页数
                console.log(this.pageIndex);
              } else {
                //数据length不足row，没有更多数据，不继续往后加载
                this.finished = true;
              }
              // this.auctions = res.data;
            }
          }
        });
    },
    showResponseDialog(auction) {
      Dialog.confirm({
        message: "是否确认回应?",
      })
        .then(() => {
          fetch
            .doAnswerForSupp({
              lan: this.languageCode,
              supplierId: this.userInfo.supplierId,
              auctionNum: auction.auctionNum,
              auctionHeaderId: auction.auctionHeaderId,
              invitingBidWay: auction.invitingBidWay,
            })
            .then((res) => {
              console.log(res);
              if (res.status === "S") {
                if (res.status === "S") {
                  this.updateItem(auction.auctionNum);
                }
              }
            });
        })
        .catch(() => {});
    },
    showRejectDialg(index) {
      this.showRejectDialog = true;
      this.rejectIndex = index; //记录拒绝index
    },
    onConfirmReject() {
      if (this.rejectReason == "") {
        Toast("拒绝原因不能为空");
        return;
      }

      const auction = this.auctions[this.rejectIndex];
      fetch
        .doRefuseForSupp({
          lan: this.languageCode,
          supplierId: this.userInfo.supplierId,
          auctionNum: auction.auctionNum,
          auctionHeaderId: auction.auctionHeaderId,
          invitingBidWay: auction.invitingBidWay,
          refusalCause: this.rejectReason,
        })
        .then((res) => {
          if (res.status === "S") {
            if (res.status === "S") {
              this.updateItem(auction.auctionNum);
            }
          }
        });

      this.rejectIndex = -1;
    },
    updateItem(code) {
      fetch
        .listByPageForBidToMobile({
          lan: this.languageCode,
          auctionNum: code,
        })
        .then((res) => {
          console.log(res);
          if (res.status === "S") {
            if (res.status === "S") {
              if (res.data == null || res.data.length == 0) return;
              const auction = res.data[0];
              const index = this.auctions.findIndex((item) => {
                return item.auctionNum == code;
              });
              this.auctions.splice(index, 1, auction);
            }
          }
        });
    },
    onCancelReject() {
      this.rejectIndex = -1;
    },
    /**取快码信息*/
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)
    },
    /**格式化数字*/
    getFormatNumberValue(val) {
      return new SrmCommonUtils(this).getFormatNumberValue(val)
    }
  },
  watch: {},
  mounted() {},
};



// WEBPACK FOOTER //
// ./src/page/srm/auction/auctionList.vue